var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 157.5C130.98 157.5 156.5 131.98 156.5 100.5C156.5 69.0198 130.98 43.5 99.5 43.5C68.0198 43.5 42.5 69.0198 42.5 100.5C42.5 131.98 68.0198 157.5 99.5 157.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170 102.5C170 140.332 138.66 171 100 171C61.3401 171 30 140.332 30 102.5C30 64.6685 61.3401 34 100 34C138.66 34 170 64.6685 170 102.5ZM40.5181 102.5C40.5181 134.647 67.1491 160.707 100 160.707C132.851 160.707 159.482 134.647 159.482 102.5C159.482 70.353 132.851 44.2927 100 44.2927C67.1491 44.2927 40.5181 70.353 40.5181 102.5ZM76.8572 74.0864C77.7797 73.1726 79.2843 73.1635 80.2178 74.066L100.374 93.5514L120.318 74.1798C121.249 73.2751 122.754 73.2807 123.679 74.1924L129.605 80.0354C130.53 80.947 130.524 82.4194 129.593 83.3241L109.74 102.607L129.231 121.45C130.165 122.352 130.174 123.825 129.251 124.738L123.339 130.595C122.417 131.509 120.912 131.518 119.978 130.615L100.395 111.683L80.5748 130.934C79.6434 131.839 78.1388 131.833 77.2141 130.922L71.2876 125.079C70.363 124.167 70.3685 122.695 71.2999 121.79L91.0285 102.628L70.9648 83.2315C70.0313 82.329 70.0223 80.8566 70.9448 79.9429L76.8572 74.0864Z",
    fill: "#FF717E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalError);
export default __webpack_public_path__ + "static/media/modal-error.899b61c9e8affd1cced78e3450096c01.svg";
export { ForwardRef as ReactComponent };